
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tables",
      function () {
        return require("private-next-pages/tables/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tables"])
      });
    }
  